/* The Ground Lab — layout comun: comutator alb/negru, meniu mobil, formularul „Deblochează acces” de pe Acasă
   (aceeași logică ca pe pagina bazei de date: /api/medici/unlock + abonare în Shopify Email).
   Tema se păstrează între pagini (localStorage „tgl-v5-theme”). */
(function () {
  var KEY = 'tgl-v5-theme', TOKEN_KEY = 'medici_access';
  var ERRORS = {
    invalid_name: 'Completează numele și prenumele (doar litere).',
    invalid_email: 'Adresa de email nu pare validă.',
    disposable_email: 'Te rugăm să folosești o adresă de email permanentă, nu una temporară.',
    domain_no_mail: 'Domeniul acestei adrese nu primește emailuri. Verifică dacă e scrisă corect.',
    consent_required: 'Bifează că accepți Termenii și condițiile ca să continui.',
    marketing_required: 'Accesul se acordă în schimbul abonării la emailurile The Ground Lab. Bifează acordul ca să continui.',
    rate_limited: 'Prea multe încercări de pe această conexiune. Încearcă din nou peste o oră.'
  };
  // Formularul „Deblochează acces” (Acasă și Bază de date): o singură logică, folosită și de medici-explorer.js.
  // check() întoarce mesajul de eroare sau '' dacă datele sunt complete.
  function check(f) {
    if (!f.prenume.value.trim() || !f.nume.value.trim()) return 'Completează prenumele și numele.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(f.email.value.trim())) return 'Scrie o adresă de email validă.';
    if (!f.consent.checked) return ERRORS.consent_required;
    if (!f.marketing.checked) return ERRORS.marketing_required;
    return '';
  }
  // Cere acces la /api/medici/unlock, salvează codul și abonează contactul în Shopify Email (cu acordul dat).
  // Întoarce { ok: true } sau { error: 'mesaj' }.
  function unlock(f, api, tag) {
    var prenume = f.prenume.value.trim(), nume = f.nume.value.trim(), email = f.email.value.trim();
    return fetch(api + '/api/medici/unlock', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ prenume: prenume, nume: nume, email: email, consent: true, marketing: true, company: '' })
    })
      .then(function (res) { return res.json().then(function (data) { return { res: res, data: data }; }); })
      .then(function (o) {
        if (!o.res.ok || !o.data.ok || !o.data.token) return { error: ERRORS[o.data.error] || 'Nu am putut trimite formularul. Verifică datele și încearcă din nou.' };
        try { localStorage.setItem(TOKEN_KEY, JSON.stringify({ token: o.data.token, expiresAt: o.data.expiresAt })); } catch (e) {}
        // Abonare în Shopify Email. Nu blocăm accesul dacă eșuează.
        var body = new URLSearchParams();
        body.set('form_type', 'customer'); body.set('utf8', '✓');
        body.set('contact[email]', email); body.set('contact[first_name]', prenume); body.set('contact[last_name]', nume);
        body.set('contact[tags]', tag || 'medici'); body.set('contact[accepts_marketing]', 'true');
        fetch('/contact', { method: 'POST', body: body, headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).catch(function () {});
        return { ok: true };
      })
      .catch(function () { return { error: 'Nu am putut trimite formularul. Verifică conexiunea și încearcă din nou.' }; });
  }
  window.TGL = { check: check, unlock: unlock, errors: ERRORS };
  function apply(t) {
    var dark = t === 'dark', label = dark ? 'Treci pe alb' : 'Treci pe negru';
    document.querySelectorAll('.tgl').forEach(function (r) { r.classList.toggle('tgl--dark', dark); });
    document.querySelectorAll('.medici').forEach(function (m) { m.classList.toggle('medici--ink', dark); });
    document.querySelectorAll('.tgl-toggle').forEach(function (b) { b.setAttribute('aria-label', label); b.title = label; b.setAttribute('aria-pressed', String(dark)); });
  }
  function init() {
    var root = document.querySelector('.tgl'); if (!root) return;
    var t = new URLSearchParams(location.search).get('theme');
    if (!t) { try { t = localStorage.getItem(KEY); } catch (e) {} }
    if (!t && root.hasAttribute('data-auto-theme') && window.matchMedia) t = matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
    var cur = t === 'dark' ? 'dark' : 'light'; apply(cur);
    document.querySelectorAll('.tgl-toggle').forEach(function (b) {
      b.addEventListener('click', function () { cur = cur === 'dark' ? 'light' : 'dark'; apply(cur); try { localStorage.setItem(KEY, cur); } catch (e) {} });
    });

    var mb = document.querySelector('[data-tgl-menu-toggle]'), menu = document.querySelector('[data-tgl-menu]');
    if (mb && menu) {
      var set = function (open) { menu.classList.toggle('is-open', open); mb.textContent = open ? 'Închide' : 'Meniu'; mb.setAttribute('aria-expanded', String(open)); };
      mb.addEventListener('click', function () { set(!menu.classList.contains('is-open')); });
      menu.querySelectorAll('a').forEach(function (a) { a.addEventListener('click', function () { set(false); }); });
      // Esc închide meniul și duce focusul înapoi pe butonul Meniu (altfel pierde locul când linkurile se ascund).
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape' || !menu.classList.contains('is-open')) return;
        set(false); mb.focus();
      });
    }

    document.querySelectorAll('[data-tgl-unlock]').forEach(function (form) {
      var box = form.parentElement, done = box.querySelector('[data-tgl-unlock-done]'), err = form.querySelector('[data-tgl-error]'), btn = form.querySelector('[type="submit"]');
      var fail = function (m) { err.textContent = m; err.hidden = false; };
      form.addEventListener('input', function () { err.hidden = true; });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var f = form.elements; if (f.company && f.company.value) return;
        var msg = check(f); if (msg) return fail(msg);
        btn.disabled = true;
        unlock(f, form.getAttribute('data-api'), form.getAttribute('data-tag'))
          .then(function (o) {
            if (o.error) return fail(o.error);
            form.hidden = true; done.hidden = false; done.classList.add('tgl-enter');
          })
          .then(function () { btn.disabled = false; });
      });
    });
  }
  // Hărțile de pe Despre: animația pornește când harta intră pe ecran (o singură dată).
  function maps() {
    var list = document.querySelectorAll('.tgl-harta');
    if (!list.length || !('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('tgl-harta--in'); io.unobserve(e.target);
      });
    }, { threshold: 0.4 });
    list.forEach(function (m) { m.classList.add('tgl-harta--anim'); io.observe(m); });
  }
  var calm = !('IntersectionObserver' in window) || (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  // Secțiunile apar pe rând (titlu, text, imagine) când intră pe ecran, o singură dată.
  var GROUPS = '.home-facts, .home-about__card, .home-db__band, .home-feed__head, .about-intro, .about-ch, .medici__stats';
  var ITEMS = '.home-fact, .home-about__card > *, .home-db__band > *, .home-feed__head > *, .about-intro > *, .about-ch__head, .about-split__text > p, .about-photo, .about-cols, .about-countries, .about-narrow, .medici__stats li';
  function reveal() {
    if (calm) return;
    var groups = document.querySelectorAll(GROUPS); if (!groups.length) return;
    // Fiecare element pornește când apare el pe ecran (pe telefon un capitol are 1–2 ecrane;
    // dacă porneam tot grupul odată, poza și textul de jos se animau în afara ecranului).
    // Elementele care intră împreună apar pe rând, la 70 ms unul după altul.
    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (e) { return e.isIntersecting; })
        .sort(function (x, y) { return x.boundingClientRect.top - y.boundingClientRect.top; });
      batch.forEach(function (e, i) {
        e.target.style.setProperty('--reveal-delay', Math.min(i, 6) * 70 + 'ms');
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { threshold: 0.2, rootMargin: '0px 0px -8% 0px' });
    groups.forEach(function (g) {
      g.querySelectorAll(ITEMS).forEach(function (el) {
        if (el.closest(GROUPS) !== g) return;
        el.setAttribute('data-reveal', ''); io.observe(el);
      });
    });
    document.documentElement.classList.add('tgl-reveal-on');
  }
  // Cifrele de pe Bază de date și urmăritorii de pe Acasă cresc de la 0 când ajung pe ecran.
  function counters() {
    var nums = document.querySelectorAll('.medici__stats strong, .home-fact__big'); if (!nums.length || calm) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        // Acceptă și numere cu punct de mii („23.500”) și îl păstrează la afișare.
        var el = e.target, text = el.textContent.trim(), m = text.match(/^(\D*)(\d{1,3}(?:\.\d{3})+|\d+)(.*)$/); if (!m) return;
        var dots = m[2].indexOf('.') >= 0, t0 = null, dur = 1100;
        var fmt = function (n) { return dots ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.') : String(n); };
        el.setAttribute('aria-label', text);
        (function step(t) {
          if (t0 === null) t0 = t;
          // Ținta se citește la fiecare cadru: stats() o poate actualiza din bază în timpul animației.
          var end = parseInt(el.getAttribute('data-stat-value') || m[2].replace(/\./g, ''), 10);
          var k = Math.min((t - t0) / dur, 1), eased = 1 - Math.pow(1 - k, 3);
          el.textContent = m[1] + fmt(Math.round(end * eased)) + m[3];
          if (k < 1) requestAnimationFrame(step);
        })(performance.now());
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }
  // Cifrele bazei de date (medici, specialități, orașe) vin din /api/medici/stats, ca să nu rămână vechi în setări.
  // Textul din setări rămâne ca rezervă; se înlocuiește doar numărul de la început.
  function stats() {
    document.querySelectorAll('[data-tgl-stats]').forEach(function (box) {
      var api = box.getAttribute('data-api');
      if (!api) return;
      fetch(api + '/api/medici/stats')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (data) {
          if (!data || !data.ok) return;
          box.querySelectorAll('[data-stat]').forEach(function (n) {
            var v = data[n.getAttribute('data-stat')];
            if (typeof v !== 'number') return;
            n.setAttribute('data-stat-value', String(v));
            if (n.hasAttribute('aria-label')) n.setAttribute('aria-label', n.getAttribute('aria-label').replace(/\d+/, String(v)));
            n.textContent = /^\s*\d/.test(n.textContent) ? n.textContent.replace(/^\s*[\d.\s]*\d/, String(v)) : String(v);
          });
        })
        .catch(function () {});
    });
  }
  function start() { init(); maps(); reveal(); counters(); stats(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
